export default __webpack_public_path__ + "static/media/img-49.3e727baf.jpg";